import UserEvents from "./UserEvents";
import {
    UserList,
    UpdateUserList,
    User,
    UserLogin,
    UserItems,
    UserData,
    Group,
    UserSkill,
    AccessableEmailDomain,
    AccessableEmail,
    UserLicense,
} from "./User";

// ログインユーザー情報取得
export const LoginStarted = (user: UserLogin) =>
    ({
        type: UserEvents.LoginStarted,
        user,
    } as const);

export const LoginComplete = (user: UserData) =>
    ({
        type: UserEvents.LoginComplete,
        user,
    } as const);

export const LoginFailed = (response: any) =>
    ({
        type: UserEvents.LoginFailed,
        response,
    } as const);

export const SetSessionTimeout = () =>
    ({
        type: UserEvents.SessionTimeout,
    } as const);

//ユーザー一覧取得
export const GetUserInfoList = () =>
    ({
        type: UserEvents.GetUserInfoListStarted,
    } as const);

export const GetUserInfoListComplete = (listItems: UserList[]) =>
    ({
        type: UserEvents.GetUserInfoListComplete,
        listItems,
    } as const);

// ユーザ一覧更新
export const UpdateUserInfo = (updateListItems: UpdateUserList[]) =>
    ({
        type: UserEvents.UpdateUserInfoStarted,
        updateListItems,
    } as const);

export const UpdateUserInfoComplete = (listItems: UserList[]) =>
    ({
        type: UserEvents.UpdateUserInfoComplete,
        listItems,
    } as const);

export const UpdateUserInfoFailed = () =>
    ({
        type: UserEvents.UpdateUserInfoFailed,
    } as const);

// ユーザ一プロファイル画像更新
export const UpdateUserProfileImage = (imageFile: any, profileItems: UserItems) =>
    ({
        type: UserEvents.UpdateUserProfileImageStarted,
        imageFile,
        profileItems,
    } as const);

export const UpdateUserProfileImageComplete = (user: User) =>
    ({
        type: UserEvents.UpdateUserProfileImageComplete,
        user,
    } as const);

// 新規スキル作成
export const CreateNewSkill = (newSkill: string) =>
    ({
        type: UserEvents.CreateNewSkillStarted,
        newSkill,
    } as const);

export const CreateNewSkillCompleted = (outputSkillList: UserSkill[]) =>
    ({
        type: UserEvents.CreateNewSkillCompleted,
        outputSkillList,
    } as const);

export const CreateNewSkillFailed = (outputSkillList: UserSkill[], message: string) =>
    ({
        type: UserEvents.CreateNewSkillFailed,
        outputSkillList,
        message,
    } as const);

export const ResetDuplicateSkillError = () =>
    ({
        type: UserEvents.ResetDuplicateSkillError,
    } as const);

//スキル一覧取得
export const GetSkillList = (inputSkillList: string[]) =>
    ({
        type: UserEvents.GetSkillListStarted,
        inputSkillList,
    } as const);

export const GetSkillListComplete = (outputSkillList: UserSkill[]) =>
    ({
        type: UserEvents.GetSkillListComplete,
        outputSkillList,
    } as const);

// ユーザー情報更新バッチを手動実行
export const StartSyncBatch = () =>
    ({
        type: UserEvents.StartSyncBatch,
    } as const);
export const StartSyncBatchComplete = () =>
    ({
        type: UserEvents.StartSyncBatchComplete,
    } as const);
export const StartSyncBatchFailed = (error: string) =>
    ({
        type: UserEvents.StartSyncBatchFailed,
        error,
    } as const);

// ユーザーグループ情報を取得
export const GetGroupList = () =>
    ({
        type: UserEvents.GetGroupListStart,
    } as const);
export const GetGroupListComplete = (groupList: Group[]) =>
    ({
        type: UserEvents.GetGroupListComplete,
        groupList,
    } as const);
// ユーザーグループ情報を更新
export const UpdateGroupList = (updateList: Group[]) =>
    ({
        type: UserEvents.UpdateGroupListStart,
        updateList,
    } as const);
export const UpdateGroupListComplete = (groupList: Group[]) =>
    ({
        type: UserEvents.UpdateGroupListComplete,
        groupList,
    } as const);

// アクセス可能なメールドメインのリストを取得
export const GetAccessableEmailDomainList = () =>
    ({
        type: UserEvents.GetAccessableEmailDomainListStart,
    } as const);

// アクセス可能なメールドメインのリストを完了
export const GetAccessableEmailDomainListComplete = (domainList: AccessableEmailDomain[]) =>
    ({
        type: UserEvents.GetAccessableEmailDomainListComplete,
        domainList,
    } as const);

// アクセス可能なEmailリストを取得
export const GetAccessableEmailList = () =>
    ({
        type: UserEvents.GetAccessableEmailListStart,
    } as const);

// アクセス可能なEmailリストを取得完了
export const GetAccessableEmailListComplete = (emailList: AccessableEmail[]) =>
    ({
        type: UserEvents.GetAccessableEmailListComplete,
        emailList,
    } as const);

// アクセス可能なEmailリストを更新
export const UpdateAccessableEmailDomainList = (domainList: string[], userId: number) =>
    ({
        type: UserEvents.UpdateAccessableEmailDomainListStart,
        domainList,
        userId,
    } as const);

// アクセス可能なEmailリストを更新完了
export const UpdateAccessableEmailDomainListComplete = (domainList: AccessableEmailDomain[]) =>
    ({
        type: UserEvents.UpdateAccessableEmailDomainListComplete,
        domainList,
    } as const);

// アクセス可能なメールEmailリストを更新
export const UpdateAccessableEmailList = (emailList: string[], userId: number) =>
    ({
        type: UserEvents.UpdateAccessableEmailListStart,
        emailList,
        userId,
    } as const);

// アクセス可能なメールEmailリストを更新完了
export const UpdateAccessableEmailListComplete = (emailList: AccessableEmail[]) =>
    ({
        type: UserEvents.UpdateAccessableEmailListComplete,
        emailList,
    } as const);

// ユーザーライセンス情報を取得
export const GetUserLicenseStart = (subdomain: string) =>
    ({
        type: UserEvents.GetUserLicenseStart,
        subdomain,
    } as const);

// ユーザーライセンス情報を取得完了
export const GetUserLicenseComplete = (userLicense: UserLicense[]) =>
    ({
        type: UserEvents.GetUserLicenseComplete,
        userLicense,
    } as const);
